import { render, staticRenderFns } from "./SCButton.vue?vue&type=template&id=183e53dd&"
import script from "./SCButton.vue?vue&type=script&lang=js&"
export * from "./SCButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports